import { render, staticRenderFns } from "./ElderlyGovClass.vue?vue&type=template&id=baa0365a&scoped=true&"
import script from "./ElderlyGovClass.vue?vue&type=script&lang=js&"
export * from "./ElderlyGovClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa0365a",
  null
  
)

export default component.exports